export default "/logo-v2.svg"